import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import { getI18n } from 'client/i18n'
import styles from './delete.less'
import { Link } from 'react-router'
import { formatMoney } from 'client/griffin'
import { glimpseRoute } from 'lib/route_utils'

const i18n = getI18n('components/edit_glimpse/edit_delete')

class Delete extends React.Component {
  static propTypes = {
    moneyBoxAmount: PropTypes.number,
    currency: PropTypes.string,
  }

  render() {
    let title, description
    if (this.props.moneyBoxAmount) {
      const formattedMoneyboxAmount = formatMoney(
        this.props.currency,
        this.props.moneyBoxAmount
      )
      title = i18n('title_moneybox', { amount: formattedMoneyboxAmount })
      description = i18n('delete_description_moneybox')
    } else {
      title = i18n('title')
      description = i18n('delete_description')
    }

    return (
      <div>
        <span
          className="icon icon-large icon-attention-large"
          styleName="delete-indicator"
          aria-hidden="true"
        />
        <div styleName="title" role="heading" aria-level="1">
          {title}
        </div>
        <div styleName="description">
          <p>{description}</p>
        </div>
        <Link
          to={glimpseRoute('edit', 'delete/review')}
          data-nemo="deleteButton"
          className="vx_btn vx_btn-block"
          styleName="delete-button"
        >
          {i18n('delete_action')}
        </Link>
      </div>
    )
  }
}

export default cssModules(Delete, styles)
